var _excluded = ["children", "messages", "onClose"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useEffect, Component } from 'react';
import { createPortal } from 'react-dom';
import { createEnum, ValidPropTypes, makeErrorBoundComponent, generateId, validateRequiredProps } from '@els/els-react--utils';
import PT from 'prop-types';
import { Button, ButtonWithIcon } from '@els/els-react--button';
import { Icon } from '@els/els-react--icon';
import classNames from 'classnames';
import FocusTrap from 'focus-trap-react';
var ModalTypes = createEnum(['primary', 'secondary', 'positive', 'negative', 'neutral']);
var ModalFullPageTypes = createEnum(['page', 'page-collapsed']);
var ModalPanelSizes = createEnum(['small', 'medium', 'large']);
var DefaultMessages = createEnum({
  accessibilityLabel: 'Dialog overlaying the application content',
  closeModal: 'Close modal',
  closeButton: 'Close'
});
var bool$1 = PT.bool,
  element$1 = PT.element,
  func$1 = PT.func,
  object$1 = PT.object,
  oneOf$1 = PT.oneOf,
  shape$1 = PT.shape,
  string$1 = PT.string;
var ModalContainer = function ModalContainer(_ref) {
  var children = _ref.children,
    className = _ref.className,
    hideCloseLabel = _ref.hideCloseLabel,
    focusTrapProps = _ref.focusTrapProps,
    fullPage = _ref.fullPage,
    messages = _ref.messages,
    onCloseClick = _ref.onCloseClick,
    overlayId = _ref.overlayId,
    panel = _ref.panel,
    panelRight = _ref.panelRight,
    panelSize = _ref.panelSize,
    shouldCloseOnEscape = _ref.shouldCloseOnEscape,
    shouldHideCloseButton = _ref.shouldHideCloseButton,
    type = _ref.type,
    width = _ref.width;
  var compiledMessages = _objectSpread(_objectSpread({}, DefaultMessages), messages);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    offscreen = _useState2[0],
    setOffscreen = _useState2[1];
  useEffect(function () {
    var offscreenTimer = setTimeout(function () {
      return setOffscreen(false);
    });
    return function () {
      return clearTimeout(offscreenTimer);
    };
  }, []);
  var baseClassName = "c-els-modal";
  var containerClasses = classNames(baseClassName, "".concat(baseClassName, "--").concat(type), className, {
    "c-els-modal--page": fullPage === "page",
    "c-els-modal--page-collapsed": fullPage === "page-collapsed",
    "c-els-modal--panel": panel,
    "c-els-modal--panel-offscreen": panel && offscreen,
    "c-els-modal--panel-right": panelRight,
    "c-els-modal--panel-small": panelSize === ModalPanelSizes.SMALL,
    "c-els-modal--panel-large": panelSize === ModalPanelSizes.LARGE
  });
  var closeButtonHandler = function closeButtonHandler(event) {
    setOffscreen(true);
    if (panel) {
      setTimeout(function () {
        onCloseClick(event);
      }, 250);
    } else {
      onCloseClick(event);
    }
  };
  var sharedButtonProps = {
    id: "".concat(overlayId, "-close-button"),
    onClick: closeButtonHandler,
    "data-testid": "modal-close-button",
    type: Button.Types.LINK,
    className: "".concat(baseClassName, "__close")
  };
  return /* @__PURE__ */React.createElement(FocusTrap, _objectSpread(_objectSpread({}, focusTrapProps), {}, {
    focusTrapOptions: _objectSpread(_objectSpread({}, focusTrapProps.focusTrapOptions), {}, {
      // If esc doesn't close the modal it also shouldn't break out of the focus trap
      escapeDeactivates: shouldCloseOnEscape,
      // Allows clicks on the Cookie banner when that clashes with an open modal
      allowOutsideClick: true
    })
  }), /* @__PURE__ */React.createElement("div", {
    role: "dialog",
    "aria-modal": "true",
    "aria-label": compiledMessages.ACCESSIBILITY_LABEL,
    className: containerClasses,
    "data-testid": "modal-overlay",
    id: overlayId
  }, /* @__PURE__ */React.createElement("div", {
    className: "".concat(baseClassName, "__window"),
    "data-testid": "modal-container",
    id: "".concat(overlayId, "-container"),
    style: width ? {
      width: width
    } : null
  }, !shouldHideCloseButton && /* @__PURE__ */React.createElement("div", null, !hideCloseLabel && /* @__PURE__ */React.createElement(ButtonWithIcon, _objectSpread(_objectSpread({}, sharedButtonProps), {}, {
    sprite: Icon.Sprites.CLOSE,
    iconRight: true,
    linkIconSize: "s"
  }), compiledMessages.CLOSE_BUTTON), hideCloseLabel && /* @__PURE__ */React.createElement(Button, _objectSpread({}, sharedButtonProps), /* @__PURE__ */React.createElement(Icon, {
    size: "s",
    sprite: Icon.Sprites.CLOSE,
    fallback: (/* istanbul ignore next */
    function fallback() {
      return "x";
    })
  }, compiledMessages.CLOSE_MODAL))), children)));
};
ModalContainer.displayName = "ModalContainer";
ModalContainer.propTypes = {
  children: element$1.isRequired,
  className: string$1,
  focusTrapProps: shape$1({
    active: bool$1
  }),
  /** Modal fills the Page */
  fullPage: oneOf$1(ModalFullPageTypes.getAll()),
  /** Hide the label on the close icon */
  hideCloseLabel: bool$1,
  /** Messages for internationalization */
  messages: object$1.isRequired,
  overlayId: string$1.isRequired,
  panel: bool$1,
  panelRight: bool$1,
  panelSize: oneOf$1(ModalPanelSizes.getAll()),
  shouldCloseOnEscape: bool$1,
  shouldHideCloseButton: bool$1.isRequired,
  type: string$1.isRequired,
  width: string$1,
  onCloseClick: func$1.isRequired
};
ModalContainer.requiredProps = {
  children: ValidPropTypes.NODE,
  onCloseClick: ValidPropTypes.FUNCTION,
  overlayId: ValidPropTypes.STRING,
  shouldHideCloseButton: ValidPropTypes.BOOL,
  type: ValidPropTypes.STRING
};
ModalContainer.defaultProps = {
  className: "",
  focusTrapProps: {},
  fullPage: null,
  hideCloseLabel: true,
  panel: false,
  panelRight: false,
  panelSize: ModalPanelSizes.MEDIUM,
  shouldCloseOnEscape: false,
  width: null
};
ModalContainer.DefaultMessages = DefaultMessages;
var bool = PT.bool,
  element = PT.element,
  func = PT.func,
  object = PT.object,
  oneOf = PT.oneOf,
  shape = PT.shape,
  string = PT.string;
var Modal = /*#__PURE__*/function (_Component) {
  function Modal(props) {
    var _this;
    _classCallCheck(this, Modal);
    _this = _callSuper(this, Modal, [props]);
    _defineProperty(_this, "escapeHandler", function (event) {
      var _this$props = _this.props,
        onClose = _this$props.onClose,
        shouldCloseOnEscape = _this$props.shouldCloseOnEscape;
      if ((event.key === "Escape" || event.key === "Esc") && shouldCloseOnEscape) {
        onClose();
      }
    });
    _defineProperty(_this, "clickHandler", function (event) {
      var _this$props2 = _this.props,
        shouldPreventClickOverlayToClose = _this$props2.shouldPreventClickOverlayToClose,
        onClose = _this$props2.onClose;
      if (event.target.id === _this.overlayId && !shouldPreventClickOverlayToClose) {
        onClose();
      }
    });
    var id = props.id;
    var rootId = id || "modal-".concat(generateId());
    _this.overlayId = "".concat(rootId, "-overlay");
    _this.el = document.createElement("div");
    _this.el.setAttribute("id", rootId);
    _this.el.setAttribute("data-testid", "modal");
    return _this;
  }
  _inherits(Modal, _Component);
  return _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var rootId = this.props.rootId;
      var root = rootId ? document.getElementById(rootId) : document.body;
      root.appendChild(this.el);
      document.addEventListener("keydown", this.escapeHandler);
      document.getElementById(this.overlayId).addEventListener("mousedown", this.clickHandler);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var rootId = this.props.rootId;
      var root = rootId ? document.getElementById(rootId) : document.body;
      root.removeChild(this.el);
      document.removeEventListener("keydown", this.escapeHandler);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        children = _this$props3.children,
        messages = _this$props3.messages,
        onClose = _this$props3.onClose,
        props = _objectWithoutProperties(_this$props3, _excluded);
      var compiledMessages = _objectSpread(_objectSpread({}, DefaultMessages), messages);
      return createPortal(validateRequiredProps(/* @__PURE__ */React.createElement(ModalContainer, _objectSpread({
        onCloseClick: onClose,
        overlayId: this.overlayId,
        messages: compiledMessages
      }, props), children)), this.el);
    }
  }]);
}(Component);
Modal.displayName = "Modal";
Modal.propTypes = {
  /** Content of the modal */
  children: element.isRequired,
  /** Allow custom classes for outward-looking styling (margins, width) of the component */
  className: string,
  /** The object of props used for the focus trap
   *
   *  As a note, the active property here should be used as sparingly as possible to maintain accessibility
   *
   *  @see https://github.com/focus-trap/focus-trap-react
   */
  focusTrapProps: shape({
    active: bool
  }),
  /** Modal fills the page */
  fullPage: oneOf(ModalFullPageTypes.getAll()),
  /** Hide the label on the close icon */
  hideCloseLabel: bool,
  /** Unique ID */
  id: string,
  /** Messages for internationalization */
  messages: object,
  /** Used internally by ModalPanel, therefore not documented */
  panel: bool,
  /** Documented as part of ModalPanel */
  panelRight: bool,
  /** Documented as part of ModalPanel */
  panelSize: oneOf(ModalPanelSizes.getAll()),
  /** Id of div the modal should be a child of.
   * If this value is not defined, the modal will become a child of the document.body. */
  rootId: string,
  /** Determines if the modal should be closed with the escape button */
  shouldCloseOnEscape: bool,
  /** Determines if the modal should display the close button */
  shouldHideCloseButton: bool,
  /** Determines if the modal should be closed when click on overlay */
  shouldPreventClickOverlayToClose: bool,
  /** Type of the modal expressing intended sentiment */
  type: oneOf(ModalTypes.getAll()),
  width: string,
  /** function to close the modal */
  onClose: func.isRequired
};
Modal.requiredProps = {
  children: ValidPropTypes.NODE,
  onClose: ValidPropTypes.FUNCTION
};
Modal.defaultProps = {
  className: "",
  focusTrapProps: {},
  fullPage: null,
  hideCloseLabel: true,
  id: null,
  messages: DefaultMessages,
  panel: false,
  panelRight: false,
  panelSize: ModalPanelSizes.MEDIUM,
  rootId: "",
  shouldCloseOnEscape: true,
  shouldPreventClickOverlayToClose: false,
  shouldHideCloseButton: false,
  type: ModalTypes.PRIMARY,
  width: null
};
Modal.DefaultMessages = DefaultMessages;
Modal.Types = ModalTypes;
Modal.FullPageTypes = ModalFullPageTypes;
Modal.PanelSizes = ModalPanelSizes;
var RawModal = Modal;
var Modal$1 = makeErrorBoundComponent(RawModal);
export { Modal$1 as Modal, RawModal };
